import React from 'react';
import BulmaTable from 'react-bulma-components/lib/components/table';
import classnames from 'classnames';
import './style.scss';

const Table = ({ children, striped = false, loading = false, ...props }) => {
  return (
    <BulmaTable
      striped={striped}
      className={classnames({ loading })}
      {...props}
    >
      {children}
    </BulmaTable>
  );
};

export { TableHeader } from './TableHeader';
export { Pagination } from './Pagination';
export { EmptyTable } from './EmptyTable';
export default Table;
